import { render, staticRenderFns } from "./UNavWrap.vue?vue&type=template&id=3ea662e7&scoped=true&"
var script = {}
import style0 from "./UNavWrap.vue?vue&type=style&index=0&id=3ea662e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea662e7",
  null
  
)

export default component.exports